import { isNumberOrCurrency } from './isNumberOrCurrency';

/**
 * Gets the data type for the column.  If any row is not number or currency then the data type is string
 * @param data
 * @param column
 */
export const getColumnDataType = (data, column) => {
  return data.some(item => !isNumberOrCurrency(item[column])) ? 'string' : 'number';
};